interface Iobj {
    [key: string]: any
}


const comUrl = process.env.VUE_APP_COMURL
import requestObj from './request'
const { post, get } = requestObj


export default {

    init: (e: Iobj,) => post(`${comUrl}/api/v1/page/init`, e,), //初始化


    emailLogin: (e: Iobj,) => post(`${comUrl}/api/v1/wap/login/account`, e,), //邮箱登录
    tokenLogin: (e: Iobj,) => post(`${comUrl}/api/v1/wap/login/token`, e,), //token登录
    socialLogin: (e: Iobj,) => post(`${comUrl}/api/v1/wap/login/social`, e,), //第三方登录（谷歌 facebook apple）


    getGameList: (e: Iobj,) => post(`${comUrl}/api/v1/page/game/list`, e,), //获取游戏列表
    getGameDetail: (e: Iobj,) => post(`${comUrl}/api/v1/page/game/detail`, e,), //获取游戏详情
    getServerList: (e: Iobj,) => post(`${comUrl}/api/v1/page/game/server/list`, e,), //获取服务器列表
    getRoleList: (e: Iobj,) => post(`${comUrl}/api/v1/page/game/role/list`, e,), //获取角色列表

    getProductList: (e: Iobj,) => post(`${comUrl}/api/v1/page/goods/list`, e,), //获取商品列表
    getProductDetail: (e: Iobj,) => post(`${comUrl}/api/v1/page/goods/detail`, e,), //获取商品详情

    getOrderList: (e: Iobj,) => post(`${comUrl}/api/v1/page/order/list`, e,), //获取订单列表

    order: (e: Iobj,) => post(`${comUrl}/api/v1/my/order`, e,), //页面创建订单

    payCenterOrder: (e: Iobj,) => post(`${comUrl}/api/v1/pay/order`, e,), //支付中心支付接口

    clientPaymentList: (e: Iobj,) => post(`${comUrl}/api/v1/pay/payments`, e,), //获取客户端支付列表

    checkOrder: (e: Iobj,) => post(`${comUrl}/api/v1/order/query`, e,), //检查订单状态


    getCPOrder: async (e: { p_gid: string, toCpData: any }) => {
        let res: any
        switch (e.p_gid) {
            case '2':
                res = await post(`https://xhyhw-xy.xinliugame.net/xingheyue`, e.toCpData)
                if (res.ret === 0) {
                    return {
                        code: 200,
                        data: res.data,
                        msg: res.msg
                    }
                } else {
                    return {
                        code: 500,
                        msg: res.msg
                    }
                }
                break;
            default:
                break;
        }
        return {
            code: 500,
            msg: 'cp接口匹配失败'
        }
        // const res: any = await post(`https://xhyhw-xy.xinliugame.net/xingheyue/getPayParams.php`, e.toCpData)
        // if (res.ret === 0) {
        //     return res.data
        // } else {
        //     console.log(res)
        //     return {
        //         code: 500,
        //         data: res
        //     }
        // }
    }
}